import { render, staticRenderFns } from "./c_member_card.vue?vue&type=template&id=6e96b4f3&scoped=true"
import script from "./c_member_card.vue?vue&type=script&lang=js"
export * from "./c_member_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e96b4f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e96b4f3')) {
      api.createRecord('6e96b4f3', component.options)
    } else {
      api.reload('6e96b4f3', component.options)
    }
    module.hot.accept("./c_member_card.vue?vue&type=template&id=6e96b4f3&scoped=true", function () {
      api.rerender('6e96b4f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_member_card.vue"
export default component.exports